import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import NavbarSection from "./NavbarSection";
import Footer from "./Footer";
import { useForm } from "react-hook-form";
import ToastFile from "../../utils/ToastFile";
import { useNavigate } from "react-router-dom";
import { addContact } from "../../api/contactApi";

const ContactUs = () => {
  const navigate = useNavigate();
  const [isLoading, setIsloading] = useState(false);

  const onSubmit = (data) => {
    setIsloading(true);
    console.log({data})
    addContact(data)
      .then((res) => {
        setIsloading(false);
        ToastFile(
            "Thank you for contacting us. We'll get back to you soon.",
          );
          reset()
      })
      .catch((err) => {
        setIsloading(false);
      });
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  return (
    <>
      <NavbarSection />
      <Container fluid className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
        <Container>
          <Row className="justify-content-center align-items-start">
            {/* Contact Form */}
            <Col
              xs={12}
              md={6}
              className="bg-white p-4 p-md-5 rounded shadow-sm mb-4 mb-md-0"
            >
              <h2 className="fw-bold text-dark mb-4">Contact Us</h2>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group className="mb-3" controlId="name">
                  <Form.Control
                    type="text"
                    {...register("name", { required: true })}
                    placeholder="Name"
                    isInvalid={errors.name}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="phone">
                  <Form.Control
                    type="text"
                    {...register("contact_no", { required: false })}
                    placeholder="Phone Number"
                    isInvalid={errors.contact_no}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Control
                    type="email"
                    {...register("email", { required: false })}
                    placeholder="Work Email"
                    isInvalid={errors.email}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="company">
                  <Form.Control
                    type="text"
                    {...register("companyName", { required: false })}
                    placeholder="Company Name"
                    isInvalid={errors.companyName}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="country">
                  <Form.Control
                    type="text"
                    {...register("country", { required: false })}
                    placeholder="Country"
                    isInvalid={errors.country}
                  />
                </Form.Group>
                <Form.Group className="mb-4" controlId="requirements">
                  <Form.Control
                    as="textarea"
                    {...register("requirements", { required: false })}
                    rows={3}
                    placeholder="Requirements"
                  />
                </Form.Group>
                <Button
                  type="submit"
                  className="w-100 fw-bold py-2"
                  style={{
                    backgroundColor: "#ff7b00",
                    border: "none",
                    fontSize: "1.1rem",
                  }}
                >
                  Send your message
                </Button>
              </Form>
            </Col>

            {/* Contact Info */}
            <Col xs={12} md={5} className="text-center text-md-start ps-md-5">
              <div className="mb-5">
                <h4 className="fw-bold text-dark">Want to talk to sales?</h4>
                <p className="text-secondary mb-1">
                  Call now to speak with our friendly consultants.
                </p>
                <p className="mb-1">
                  <strong>Australia:</strong> +61 466 630 141
                </p>
                <p className="mb-1">
                  <strong>Email:</strong> be.ce.tushar@gmail.com
                </p>
              </div>

              <hr />

              <div>
                <h4 className="fw-bold text-dark">
                  Need technical assistance?
                </h4>
                <p className="text-secondary mb-1">
                  Expert support at your fingertips.
                </p>
                <p className="mb-1">
                  <strong>Email:</strong> support@dailyposthub.com
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </Container>
      <Footer />
    </>
  );
};

export default ContactUs;
